<template>
	<div class="mine page">
		<div class="page-bg"></div>
		<div class="wrapper">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="header">
					<van-nav-bar class="nav-bar">
						<template #right>
							<van-icon name="setting-o" @click="showSetting()" color="#fff" />
						</template>
					</van-nav-bar>
					<div class="user-wrapper" @click="doLogin()">
						<div class="user-main">
							<van-image round class="user_img" :src="this.userInfo.header_img">
								<template v-slot:loading>
									<van-loading type="spinner" />
								</template>
							</van-image>
							<div class="login-content">
								<p class="login-btn">{{ this.userInfo.username }}</p>
								<p class="login-label">{{ userSubtitle }}</p>
							</div>
							<van-icon class="user-arrow" name="arrow" />
						</div>
						<div class="user-status-grid">
							<div class="user-status-card">
								<div class="status-icon sex">
									<van-icon name="friends-o" />
								</div>
								<div>
									<p class="status-label">性别</p>
									<p class="status-value">{{ sexText }}</p>
								</div>
							</div>
							<div class="user-status-card">
								<div class="status-icon bank">
									<van-icon name="card" />
								</div>
								<div>
									<p class="status-label">银行卡</p>
									<p class="status-value">{{ bankText }}</p>
								</div>
							</div>
							<div class="user-status-card real-status-card" @click.stop="toRealNameAuth()">
								<div class="status-icon real">
									<van-icon name="idcard" />
								</div>
								<div>
									<p class="status-label">实名认证</p>
									<p class="status-value">{{ realNameText }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content">

					<div style="margin-top: 15px">
						<van-cell @click="refresh()">
							<template>
								<div style="display: flex ;justify-content: space-between;">
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-920d1dea="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ6SURBVHgB5VZLkhJBEH3ZDYSs5AjtDiKMkBZ1K9yAOYHMCWY8gdxgZk7AeAL1BODeGNrVzI7yBuwa+VSaWU3HIPIpwN28iIyu7srOV5WVnwKeCmjbxHTK9QWhgiMQMsalEiXwJU1TjsIiegw0cRqMDdEqE5mdpEoYFNGXYSQylllDsmociJUFm1KImIi225hM+fL3nFlklDJHOBK6eLWhttIZd3cqT+fcXyo2cSLETlttTWb8dX0u2PUjM/dFRiIfsAei01zqX+m7zY+F8Hxdt7DHVrSUWzHWladG5E8Rs5xXg3WRtkge6Xsjfh9pS6Qr8n5lAe0turqzG5FrnEJKWbh3dKzuQxaVr/C4GyX6JaLnluyMUl/StQUM5DHAf4A36bB+H9mQriQJvzfuqs6Fw8bDBTM6ZPksTmrG15Y36QyLSsgFPc+2LMClgXXBRRUCqcuNr63AV/Fd8jKR6jTQMRP1pC53lVB2buKk+g0HwGun6loO6AtDqxQJKZqUV1Diyt3rhyHZtBUnsVcgee1UXcsuH2lDDpKbm+NZHZ7wIlXXBpZfWMsttvYs/86Wz/Xbws7jt0ltAE94undYkcj9FGpxYLezbMUhufLIXDCi89HXvV6kMxQjacwdXvsu6dLMx+Lez/DMYy9Sde+P+v05B4jIpQguHCnsDYPGBRuMGkl1AE945+mbpHarT1ckAnKkoaXrQ4rCRlLOaimCwr/t6BGTMbhsdHQMobO/+iI9UNsWaIFLKfAbW5QGS8BprLLNqP4bEHrZS2ZzFbSuPF1giKyFGaLjCrwEWN5fN17ONt4GVy5np8DvNvgXud6T+EhiuUWWi64VPnH8AQHXLP/FPd2dAAAAAElFTkSuQmCC">
										<span>{{ $t('我的钱包') }}</span>
									</div>
									<div style="display:flex;align-items: center;">
										<img style="width: 20px;margin-right: 10px" data-v-42038ca9=""
											src="data:image/png;base64,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"
											alt="" class="refresh">
										<span style="color:#fff;font-size: 16px">{{ this.userInfo.money }} </span>
									</div>
								</div>

							</template>
						</van-cell>
						<div style="margin-top: 15px">
							<!-- <van-cell is-link @click="toService()">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img
										style="width: 6vw;"
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIUSURBVHgBlVRLctNAEO0ejRJYxTdArFm5EtgSL9ixMCewfQKbJUmoyJVysnVOwOcCTk5gsSZG4gToBgg2UJ6ZbnpkQsk/kfRCquqZfv26+/Ug1BjHacOEJkLChnY6w7hZbLuLm5zz0U0XQXUYOFIACTM3xB0BKkDEsT5qfqgF8gxsyBNALpjdcOf4WVY9/3WRRoFzsULkwKjXVYa6erEEIfdJyhjbHdWfj2YT9EwWOTNkGOuTg645+xzbECfibK0x8uUI8ecE7hIhmIqrAZt7kQubltEuJoXZg6P98QojPGWiHqrtIGX5wtCFNHUqaGmiVFwlkPIfc56eImDBiN06EKFzdQumrO3Kv/h9PhuUR/bsps2qrLfWfEn6eP+xGX0Rxny4dEjUUqRqGCysAObE92XBhtZGz4yR3hhKNJRvItPLZcR59Sg0wZUN6d1qyBoQAV/vvn0awxbz2jGj2ZJPqeC79hlklIfSgz1RrigZ9+AORgBDiekgc65PmtdLyvbKDYmm0o+mz8wvP7ZBu2QRqfvw016aF08kWTDxjRfBfguld758VQV6+KaZiyBfzQM7+Od0WtSuU2D8gUmvYMK2b/z8Iu37Pbzt4calLXeKTGN117yVL8IudBTRIPjLZivQMiBNEdV7dO6rSOWRvAptYAJtg151oroOCJ1tC0iETF1QmAifTBsUgIMc7mul8uM0+t+9P0Bd+FIM84WjAAAAAElFTkSuQmCC"
										alt="">
										<span>{{ $t('我的客服') }}</span>
									</div>
								</template>
							</van-cell> -->
							<van-cell is-link @click="$router.push('/GameRecord')">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIZSURBVHgB3ZVBVsIwEIbTPjfu8AbsFDfWgu+57A3EE4AnQE5AOQF4AvEE4gm6FyUsfAJuyg3gAnScoQmE2oSK4PP5vzekpJP50ulkythfFHd4rlcaeln9ASCPFqLdyjk76+K5fRjYkRX0nHUgbUKzpIyWR7v6NgwYPOHP5ICxyRLkfrQi+3Ca3ADJsqw2DtfCfq6e83776o6g7444+w0RjCyLb+Y0pokXR7XFBaxSuxcYL44rEbD2IghYfpY1RhiWbQ7NSwdBh64jBs3zwfHD2v3LYT6tSi1mhgU4eGg+VlczDXTRL/jS/8UdVjFgC8NK0ASiqF4anHaNMDqUOITKlD84H9xRqaeBuDtu4JwvFs/iR1lC68X+SduURk+MMwlzuFMjSISLdSC6V+SFIzLyjdmrg617sgBiVdB8WKmi+hFIlj+lMRmHDryhyyz7GmmqzH0B9tz4UOtASenSWBZjV05ggfg4NMXfzgIYLXYxw1Z2U+oXOmqA54s3BzcRoi0b8YEGVhPjWkkTECF02SBgiReqOHeUFsCa2x6LG/EZ0wmDOSJVocFHTWlZ55flfXVEkHtmkAKc0gbZNhIfPEjrHAk/6i6PWwMJYEqhAJTpqQVA1ZXiF6C1NsFkCtsJQFUESAICkU5P8ZfHBjbBQplCtBqsDnYSQPfyzJwhj21w0EkCcmwXotQpwacCUN0ZIAFzxIv39gL41/oEwHc878uPxPAAAAAASUVORK5CYII="											alt="">
										<span>{{ $t('打赏记录') }}</span>
									</div>
								</template>
							</van-cell>
							<van-cell v-if="false" is-link @click="$router.push('/WithdrawRecord')">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJFSURBVHgBnVVdctMwEJaUDgxPmBPgPPKExgzv5gSEE8Q9AeUEmBMETuBwgoYTuH1uwTyRDC9OT5Dw1JlO6mXXXTXbrd2m3ZkdSatP3/7JsjF3CACkqAVqDVuh+SHq2DxG8KBHLQVhxU4Olb1+kBMCo65Yc9SoAxOhZiKjz7sQpyKieAd8zFmRHNwHrDVxlfydVMliIrE/k0URbJxFzZnGErcn5lQ72systctg3DSbM+fcBAkj15x/gsEzrLtJNwa+0D5i10i6j9MStUB9F85aEXnN4KFKypwk89wZi3W1a0RGDRK//fUqV5kTeYr6ghySzfGG56h/aOLqzeKjs/YlolpickDrU/9npKDfeRzpssQ8lpr8Ektg2wMhSXQAJjPO0S2aCeiR4rqKHCVct3+afNCc77snMARr2tsABto12c09sqfWzzWgbeBFG30r1tiiuUC7fUollKWJOsmxAVOsOzXhWAOay+YbOHuMDX3NZFNs6BlAM1NQz2O1jezqfn9ljU2PnCbzDK8jnPh52rUvnoVIRk5NjHn9Hjc/YCa/bx1uzNJaWIMZrDuIKeqUsgrXMGyQzFBH4k3xpkdEpmOex31faEhnxZ+xFw7iHvIKbsqKx3EXODxW4a0IDiiatAMfoqRXcSqckL3oi/7aOzuo2VZyCbwKphJlylRG5XVjVd28sMnIdBlIchWk/MnEulGh3gfCHnG0OaddshY9ZctvkasMoLN+O4gktx2bMQ7U3PBpH6Euze7iWYd3RZDB9po+VNqr/R/IOAT2qcgW+AAAAABJRU5ErkJggg=="											alt="">
										<span>{{ $t('提现记录') }}</span>
									</div>
								</template>
							</van-cell>
							<van-cell is-link @click="$router.push('/Account')">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<van-icon class="menu-van-icon" name="balance-list-o" />
										<span>资金记录</span>
									</div>
								</template>
							</van-cell>
							<van-cell is-link @click="doWithdrawal()">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJFSURBVHgBnVVdctMwEJaUDgxPmBPgPPKExgzv5gSEE8Q9AeUEmBMETuBwgoYTuH1uwTyRDC9OT5Dw1JlO6mXXXTXbrd2m3ZkdSatP3/7JsjF3CACkqAVqDVuh+SHq2DxG8KBHLQVhxU4Olb1+kBMCo65Yc9SoAxOhZiKjz7sQpyKieAd8zFmRHNwHrDVxlfydVMliIrE/k0URbJxFzZnGErcn5lQ72systctg3DSbM+fcBAkj15x/gsEzrLtJNwa+0D5i10i6j9MStUB9F85aEXnN4KFKypwk89wZi3W1a0RGDRK//fUqV5kTeYr6ghySzfGG56h/aOLqzeKjs/YlolpickDrU/9npKDfeRzpssQ8lpr8Ektg2wMhSXQAJjPO0S2aCeiR4rqKHCVct3+afNCc77snMARr2tsABto12c09sqfWzzWgbeBFG30r1tiiuUC7fUollKWJOsmxAVOsOzXhWAOay+YbOHuMDX3NZFNs6BlAM1NQz2O1jezqfn9ljU2PnCbzDK8jnPh52rUvnoVIRk5NjHn9Hjc/YCa/bx1uzNJaWIMZrDuIKeqUsgrXMGyQzFBH4k3xpkdEpmOex31faEhnxZ+xFw7iHvIKbsqKx3EXODxW4a0IDiiatAMfoqRXcSqckL3oi/7aOzuo2VZyCbwKphJlylRG5XVjVd28sMnIdBlIchWk/MnEulGh3gfCHnG0OaddshY9ZctvkasMoLN+O4gktx2bMQ7U3PBpH6Euze7iWYd3RZDB9po+VNqr/R/IOAT2qcgW+AAAAABJRU5ErkJggg=="											alt="">
										
										<span>{{ $t('提现') }}</span>
									</div>
								</template>
							</van-cell>
							<van-cell is-link @click="$router.push({ path: '/Setbank' });">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgB7ZXBDcIwDEV/UO8wQrhxrOgCMAGMwAiMwgaM0i4A9Mit2QAxQXBEIwWDECGmh4gnWWniqD+OLQf4E4EKJ9bakoYN2RhpXMl2SikDJrCwslzINBepybo+miSCA++5wwnUECL83wgDULB5KRiNJjOvRLxTFC7SUtktIYDLif8eJCf5iBQxmw/zs7tn/WaLqY6zKV+Mi8R+54+KpDo9n/IT8q2uCX5AmBND5lr0lsYWaaxwr8LmYdU9MH17lqLzj5biRyDHGunXZqgHNsiOG7tz9HrNgLbZAAAAAElFTkSuQmCC"	
/>
<span>{{$t('银行卡管理')}}</span>
									</div>
								</template>
							</van-cell>
							<van-cell is-link @click="toRealNameAuth()">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<van-icon class="menu-van-icon" name="idcard" />
										<span>实名认证</span>
									</div>
								</template>
							</van-cell>

							<van-cell is-link @click=doPay()>
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHXSURBVHgBtVXLUcNADNXaKcAlmGNuYRjupgOoIKGCQAVJKoipAFMB6cDhzMHmBDebCpLcYAZbSLE8rO21QxJ4MxrFK+1brT4bAAIijklWeBgSkiEY0CPDhPSUJBbZFx5JQDyglHqoWORkFgcOAO+TW4cmI+MejgATc4D1dQv+Eb36QnT2NkaAy10bswxn53F/uRd5huCpokidUBa+kFruRW7neJsBUtVVZ4Ft+FzADjTIT+N+SiqFP0CD/Hnw6lm2qgwFYr6xc+XLwQ1Qf1/8ilxZag4Ig8oaNVVmIQ9YAC2gVuQ9LklMh6VGcsr51ZcFowp5rlY2fCw6iHlORtr3aDutxw4REwmHL78TmVjH6tjkyIZEJtBtcS1T6FO0AWl+X7jTnF5HUBFIDqHo+4gOOCGCdc0vFT0kO/d+2QxrY1ro25P1ee37ph6B3DCpPcNTtrVFXka3gd1wRFKSGWu63bI82VhQWovEFuLPHwlH6HLb8R6xhWJrvkcd5EwSaAWdaIfUdWi8E7Y99GZfV8uvK2vbm5n8Oed3JBOJ/r2Fd0155FZLye8Jii4q68Kai+oYOml7uo/dSDRfT8t/KL8fTREpbVNZdSPK90J8p1D0M/vzHFzr9hLf5HwF/zVh/YIAAAAASUVORK5CYII="											alt="">
										<span>{{$t('充值')}}</span>
									</div>
								</template>
							</van-cell>
							<van-cell v-if="false" is-link @click="$router.push({ path: '/pickgirl' });">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHXSURBVHgBtVXLUcNADNXaKcAlmGNuYRjupgOoIKGCQAVJKoipAFMB6cDhzMHmBDebCpLcYAZbSLE8rO21QxJ4MxrFK+1brT4bAAIijklWeBgSkiEY0CPDhPSUJBbZFx5JQDyglHqoWORkFgcOAO+TW4cmI+MejgATc4D1dQv+Eb36QnT2NkaAy10bswxn53F/uRd5huCpokidUBa+kFruRW7neJsBUtVVZ4Ft+FzADjTIT+N+SiqFP0CD/Hnw6lm2qgwFYr6xc+XLwQ1Qf1/8ilxZag4Ig8oaNVVmIQ9YAC2gVuQ9LklMh6VGcsr51ZcFowp5rlY2fCw6iHlORtr3aDutxw4REwmHL78TmVjH6tjkyIZEJtBtcS1T6FO0AWl+X7jTnF5HUBFIDqHo+4gOOCGCdc0vFT0kO/d+2QxrY1ro25P1ee37ph6B3DCpPcNTtrVFXka3gd1wRFKSGWu63bI82VhQWovEFuLPHwlH6HLb8R6xhWJrvkcd5EwSaAWdaIfUdWi8E7Y99GZfV8uvK2vbm5n8Oed3JBOJ/r2Fd0155FZLye8Jii4q68Kai+oYOml7uo/dSDRfT8t/KL8fTREpbVNZdSPK90J8p1D0M/vzHFzr9hLf5HwF/zVh/YIAAAAASUVORK5CYII="											alt="">
										<span>{{$t('选妃')}}</span>
									</div>
								</template>
							</van-cell>
							<!-- <van-cell is-link @click="exit()">
								<template>
									<div style="color:#fff;font-size: 14px" class="icons">
										<img data-v-42038ca9=""
											src="data:image/png;base64,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"
											alt="">
										<span>{{ $t('游戏记录') }}</span>
									</div>
								</template>
							</van-cell> -->

						</div>

					</div>

					<!-- <div style="margin-top: 15px">
						<van-cell is-link @click="$router.push({ path: '/GameRecord' });">
							<template>
								<div style="color:#fff;font-size: 14px" class="icons">
									<img data-v-42038ca9=""
										src="data:image/png;base64,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"
										alt="">
									<span>報酬実績</span>
								</div>
							</template>
						</van-cell>

						<van-cell is-link @click="toNotice()">
							<template>
								<div style="color:#fff;font-size: 14px" class="icons">
									<img data-v-42038ca9=""
										src="data:image/png;base64,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"
										alt="">
									<span>私のメッセージ</span>
								</div>
							</template>
						</van-cell>
						<van-cell is-link @click="$router.push({ path: '/Setbank' });">
							<template>
								<div style="color:#fff;font-size: 14px" class="icons">
									<img data-v-42038ca9=""
										src="data:image/png;base64,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"
										alt="">
									<span>{{ $t('银行卡管理') }}</span>
								</div>
							</template>
						</van-cell>
						<van-cell is-link @click="$router.push({ path: '/Setting' });">
							<template>
								<div style="color:#fff;font-size: 14px" class="icons">
									<img data-v-42038ca9=""
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDA2IDc5LmRhYmFjYmIsIDIwMjEvMDQvMTQtMDA6Mzk6NDQgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMi40IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBFRTRBMzREOTQ4MDExRUNBN0QwRkE2RDJCODUzQzNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBFRTRBMzRFOTQ4MDExRUNBN0QwRkE2RDJCODUzQzNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEVFNEEzNEI5NDgwMTFFQ0E3RDBGQTZEMkI4NTNDM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEVFNEEzNEM5NDgwMTFFQ0E3RDBGQTZEMkI4NTNDM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kVDM6AAAD40lEQVR42uyaW0hUQRjHz3Z5qNCMRM0KQrqplQWlCUr3IkvBLLtBBILZ1V6ql+qll+gClklFET5kFwkDi7YLRlaQl+6bRRRkhWb3G6YV7ek/+QW7W2fOOTNnzynZb/mx7NkzM+e/M/PNN9+sS1VVpTNZF6WTWUjQv27d/D41nBCtpztYAvqDx+CIgTIDQA4IA/XgnLCKxLkagsRsEdgI4n2urQG54JlGmTywA0T4XDsJNoN7lg055vBMkAlqQRmID/guBdwBk/9Sbis4CCICrmcDDygCkWaehTOHVCOkAwwPtRIkc+7Dr69WgVIwDcwHHrBBp/5CgGGrrjf4PH4KXL7rkNdTrtej+WC/jXP8NpgEPnCH2chcIS830GYxzEaDM8JeTidqyHDIE6eCUeCu1YK+Obi89AhGD7nBd1pz7LRmcEtQEPfeFlANptosqNrM6DDTQ8weOiDoo7hTUHQFJTkwf9KD5eXGgDQHBCVSGFVupaB4cgpO2XFaM4+ZE+T1EzQBRIKJYDnoKvFALfQeI1HHUbAWXAJN4CLbHxjpobFUeLDkr8ocSBE4D577RBuz6MHiBOpMIXwXe7dmLPe5pvT3rxktKaaYthC8KL8EFEi28wX0DRu/tF2rh9ItEHNAR8yvOJiGMXtfIdFWT4BIXjmlIcibbMGqnm/i/pUgi3avopbEEaTGSQraIlBmO9gl0eYgTafgVdVIiYp/gAqBcm5JQRE8LxcuUfFL8Eqg3CPwhpYIEQvnrUOu/zBz1cbroU8SFTPvGCXQS0MkeofZa56gdxIVs0hiDthnstxMyR5q4jmFRsnKNwkIWifZZiOvh+olK4+lRMoyg/eXSK5BzGo5grxVNAeiJBpgC+tXm0KfGnBfLzjNorWhj0RDq8H0IASngWKyjUTbtRRps83ccNo+iEzcYWCvhduHJ2Cn0pF8bKbPhvdDzNtVEtvAYnBY4mFiJHvDA1ic2W7VjrWMhmCxAwsnS53NMCLGbE5hj9JxbBJtsyA2Sl4EI0nC7KrScUhlpzUEK+tjxVyQjqb1zP/Ai/+KBamqYvtrHujFu4PTQ1zxaYozh8z9KHFTbfWQa3Nwi9AajDl0wYKwSMSegpvBENROebDLlG0xY+8FQym2wGdSdsi8UzBgN8BQxfjRJBumqyiGS1AMpHJ9bDe15RH3cughAzSBAjAOnObcVwcSQAloBQ/AQpCnU38FGAEKwVsjz6TdQ+b+qHAdZIIMUBfwXSlIUdiG8c9yh6hMc8D1K2AKyAENiuAfFQLOh4TMTcym3ADLaV8zUIYdBC8AvWnSn7XCg7hC/5cLCQoJkrKfAgwAQNfjOk/cspEAAAAASUVORK5CYII="
										alt="">
									<span>{{ $t('设置') }}</span>
								</div>
							</template>
						</van-cell>
					</div> -->





					<!--            <div class="finance">-->
					<!--            <div class="finance-item"  @click="doPay()">-->
					<!--              <van-icon class="icon" style="" name="peer-pay" />-->


					<!--              <span class="text">{{ $t('充值') }}</span>-->
					<!--            </div>-->
					<!--            <div class="line"></div>-->
					<!--            <div class="finance-item"  @click="doWithdrawal()">-->
					<!--              <van-icon class="icon" name="idcard" />-->
					<!--              <span class="text">{{ $t('提现') }}</span>-->
					<!--            </div>-->
					<!--          </div>-->
					<!--            <div v-if="this.userInfo.money" class="wallet">-->
					<!--                <div class="part-1 van-hairline&#45;&#45;bottom">-->
					<!--                  <p class="flex-1 font-28 font-primary-color">{{ $t('我的钱包') }}</p>-->
					<!--                  <span class="font-28 font-gray">{{ $t('详情') }}</span>-->
					<!--                  <van-icon class="font-gray" style="font-size: 28px" name="arrow" />-->
					<!--                </div>-->
					<!--                <div class="part-2">-->
					<!--                  <p class="balance van-ellipsis">{{this.userInfo.money}}</p>-->
					<!--                  <span class="font-28 font-gray">{{ $t('余额(元)') }}</span>-->
					<!--                  <div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>-->
					<!--                </div>-->
					<!--            </div>-->
					<!--            <div :style="{ marginTop: menu_top +'px'}" class="menu" >-->
					<!--              <div class="menu-item" @click="$router.push({path:'/Personalreport'});">-->
					<!--                <van-image class="menu-item-icon" src="img/mine/baobiao.svg">-->
					<!--                  <template v-slot:loading>-->
					<!--                    <van-loading type="spinner"/>-->
					<!--                  </template>-->
					<!--                </van-image>-->
					<!--                <span class="menu-item-label" >{{ $t('個人的な声明') }}</span>-->
					<!--              </div>-->
					<!--              <div class="menu-item" @click="exit()">-->
					<!--                <van-image class="menu-item-icon" src="img/mine/mingxi.svg">-->
					<!--                  <template v-slot:loading>-->
					<!--                    <van-loading type="spinner"/>-->
					<!--                  </template>-->
					<!--                </van-image>-->
					<!--                <span class="menu-item-label" >{{ $t('アカウントの詳細') }}</span>-->
					<!--              </div>-->
					<!--              <div class="menu-item" @click="$router.push({path:'/GameRecord'});">-->
					<!--                <van-image class="menu-item-icon" src="img/mine/youxi.svg">-->
					<!--                  <template v-slot:loading>-->
					<!--                    <van-loading type="spinner"/>-->
					<!--                  </template>-->
					<!--                </van-image>-->
					<!--                <span class="menu-item-label" >{{ $t('任务记录') }}</span>-->
					<!--              </div>-->
					<!--              <div class="menu-item" @click="$router.push({path:'/Infomation'});">-->
					<!--                <van-image class="menu-item-icon" src="img/mine/user.svg">-->
					<!--                  <template v-slot:loading>-->
					<!--                    <van-loading type="spinner"/>-->
					<!--                  </template>-->
					<!--                </van-image>-->
					<!--                <span class="menu-item-label" >{{ $t('个人中心') }}</span>-->
					<!--              </div>-->
					<!--              <div class="menu-item" @click="toNotice()">-->
					<!--                <van-image class="menu-item-icon" src="img/mine/gonggao.svg">-->
					<!--                  <template v-slot:loading>-->
					<!--                    <van-loading type="spinner"/>-->
					<!--                  </template>-->
					<!--                </van-image>-->
					<!--                <span class="menu-item-label" >{{ $t('信息公告') }}</span>-->
					<!--              </div>-->
					<!--              <div class="menu-item" @click="toService()">-->
					<!--                <van-image class="menu-item-icon" src="img/mine/kefu_1.svg">-->
					<!--                  <template v-slot:loading>-->
					<!--                    <van-loading type="spinner"/>-->
					<!--                  </template>-->
					<!--                </van-image>-->
					<!--                <span class="menu-item-label" >{{ $t('在线客服') }}</span>-->
					<!--              </div>-->
					<!--            </div>-->
				</div>
			</van-pull-refresh>
		</div>
	</div>

</template>

<script>
export default {
	data() {
		return {
			userInfo: {
			},
			menu_top: 40,
			isLoading: false,
			isBank: false,
			realNameInfo: {},
		};
	},
	computed: {
		userSubtitle() {
			if (!localStorage.getItem('token')) {
				return '\u767b\u5f55\u540e\u53ef\u67e5\u770b\u8d26\u6237\u8d44\u6599';
			}
			return this.userInfo.id ? 'ID: ' + this.userInfo.id : '\u6b22\u8fce\u56de\u6765';
		},
		sexText() {
			if (this.userInfo.sex === 1 || this.userInfo.sex === '1') {
				return '\u7537';
			}
			if (this.userInfo.sex === 2 || this.userInfo.sex === '2') {
				return '\u5973';
			}
			return '\u672a\u8bbe\u7f6e';
		},
		bankText() {
			return this.isBank ? '\u5df2\u7ed1\u5b9a' : '\u672a\u7ed1\u5b9a';
		},
		realNameText() {
			const status = this.realNameStatus;
			if (status === 'approved') {
				return '已通过';
			}
			if (status === 'pending') {
				return '审核中';
			}
			if (status === 'rejected') {
				return '已拒绝';
			}
			return '未认证';
		},
		realNameStatus() {
			const value = this.realNameInfo.real_status !== undefined ? this.realNameInfo.real_status
				: this.realNameInfo.auth_status !== undefined ? this.realNameInfo.auth_status
					: this.realNameInfo.is_real !== undefined ? this.realNameInfo.is_real
						: this.realNameInfo.status;
			const label = String(this.realNameInfo.status_text || this.realNameInfo.status_name || this.realNameInfo.audit_status_text || this.realNameInfo.msg || '').toLowerCase();

			if (label.indexOf('拒') !== -1 || label.indexOf('驳') !== -1 || label.indexOf('fail') !== -1 || label.indexOf('reject') !== -1) {
				return 'rejected';
			}
			if (label.indexOf('通过') !== -1 || label.indexOf('成功') !== -1 || label.indexOf('approved') !== -1 || label.indexOf('pass') !== -1) {
				return 'approved';
			}
			if (label.indexOf('审核') !== -1 || label.indexOf('待审') !== -1 || label.indexOf('提交') !== -1 || label.indexOf('pending') !== -1 || label.indexOf('review') !== -1) {
				return 'pending';
			}
			if (value === 1 || value === '1' || value === true) {
				return 'approved';
			}
			if (value === -1 || value === '-1' || value === 3 || value === '3') {
				return 'rejected';
			}
			if (value === 2 || value === '2') {
				return this.realNameInfo.reject_reason || this.realNameInfo.reason ? 'rejected' : 'pending';
			}
			if (value === 0 || value === '0') {
				return 'pending';
			}
			return 'not_submitted';
		}
	},
	methods: {
		refresh() {
			this.isLoading = true;
			setTimeout(() => {
				this.isLoading = false;
				if (localStorage.getItem('token')) {
					this.$toast(this.$t("刷新成功"));
				} else {
					this.$router.push({ path: '/Login' })
				}
			}, 500);
		},
		exit() {
			this.$toast(this.$t("请完成任务单后进入"));
		},
		showSetting() {
			if (localStorage.getItem('token')) {
				this.$router.push({ path: '/Setting' })
			} else {
				this.$router.push({ path: '/Login' })
			}
		},
		toNotice() {
			if (localStorage.getItem('token')) {
				this.$router.push({ path: '/Notice' })
			} else {
				this.$router.push({ path: '/Login' })
			}
		},
		onRefresh() {
			setTimeout(() => {
				this.isLoading = false;
				if (localStorage.getItem('token')) {
					this.getUserInfo();
					this.getUserBankInfo();
					this.getRealNameStatus();
					this.$toast(this.$t("刷新成功"));
				} else {
					this.$router.push({ path: '/Login' })
				}
			}, 500);
		},
		doLogin() {
			if (localStorage.getItem('token')) {
				this.$router.push({ path: '/Infomation' });
			} else {
				this.$router.push({ path: '/Login' })
			}
		},
		doPay() {
			if (localStorage.getItem('token')) {
				this.$router.push({
					name: 'Recharge',
					params: {
						balance: this.userInfo.money
					}
				});
			} else {
				this.$router.push({ path: '/Login' });
			}
		},
		toRealNameAuth() {
			if (localStorage.getItem('token')) {
				this.$http({
					method: 'get',
					url: 'realname_status'
				}).then(res => {
					if (res.code === 200) {
						const data = res.data || {};
						this.$router.push({
							path: '/RealNameAuth',
							query: {
								status: data.status || data.real_status || data.auth_status || data.is_real || 0
							}
						});
					} else {
						this.$toast(res.msg || '获取实名认证状态失败');
					}
				}).catch(() => {
					this.$toast.fail('获取实名认证状态失败');
				});
			} else {
				this.$router.push({ path: '/Login' });
			}
		},
		doWithdrawal() {
			this.$http({
				method: 'get',
				url: 'user_get_bank'
			}).then(res => {
				if (res.data.is_bank) {
					this.$router.push("withdraw");
				} else {
					this.$router.push("Setbank");
					this.$toast.fail(this.$t("请设置收款卡!"));
				}
			})
		},
		toService() {
			if (this.$store.getters.getBaseInfo.iskefu == 1) {
				this.$router.push("ServiceOnline");
			} else {
				this.$toast.fail(this.$t("功能已禁用"));
			}
		},
		getUserInfo() {
			this.$http({
				method: 'get',
				url: 'user_info'
			}).then(res => {
				if (res.code === 200) {
					console.log(res.data, 'res.data;')
					this.userInfo = res.data;
					this.menu_top = 15;
					if (this.userInfo.status !== 1) {
						this.$toast(this.$t("账号下线"));
						localStorage.clear()
						this.$router.push({ path: '/Login' })
					}
				} else if (res.code === 401) {
					this.$toast(res.msg);
				}
			})
		},
		getUserBankInfo() {
			this.$http({
				method: 'get',
				url: 'user_get_bank'
			}).then(res => {
				if (res.code === 200) {
					this.isBank = !!res.data.is_bank;
				} else if (res.code === 401) {
					this.$toast(res.msg);
				}
			})
		},
		getRealNameStatus() {
			this.$http({
				method: 'get',
				url: 'realname_status'
			}).then(res => {
				if (res.code === 200) {
					this.realNameInfo = res.data || {};
				} else if (res.code === 401) {
					this.$toast(res.msg);
				}
			})
		},
	},
	created() {
		if (localStorage.getItem('token')) {
			this.getUserInfo();
			this.getUserBankInfo();
			this.getRealNameStatus();
		} else {
			this.userInfo.username = this.$t("登录/注册");
			this.userInfo.ip = this.$t("登录可享受更多服务");
			this.userInfo.header_img = "img/mine/avatar.png";
		}
	}
};
</script>

<style scoped>
.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
}

.mine {
	position: relative;
	bottom: 10px;
	background-color: #29243d;
}

.mine .wrapper {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 15vw;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}

.mine .header {
	background-color: #29243d;
}

::v-deep .van-nav-bar__content {
	height: 100px;
	background-color: #29243d;
}

::v-deep .van-hairline--bottom::after {
	border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
	font-size: 45px;
}

.mine .header .user-wrapper {
	display: flex;
	align-items: stretch;
	padding: 32px;
    margin: 0 24px .4rem;
    border-radius: 16px;
    color: #fff;
    background: linear-gradient(145deg, #3d3454 0%, #342f46 58%, #2f2943 100%);
	box-shadow: 0 12px 28px rgba(0, 0, 0, .18);
	flex-direction: column;
}

.mine .header .user-main {
	display: flex;
	align-items: center;
	width: 100%;
}

.mine .user_img {
	flex: 0 0 auto;
	height: 118px;
	width: 118px;
	border: 4px solid rgba(255, 255, 255, .16);
	box-shadow: 0 8px 18px rgba(0, 0, 0, .22);
}

::v-deep .van-loading__spinner {
	height: 50px;
	width: 50px;
}

::v-deep .van-image__error-icon {
	font-size: 70px;
}

.mine .header .user-wrapper .login-content {
	flex: 1;
	min-width: 0;
	margin-left: 24px;
}

.mine .header .user-wrapper .login-content .login-btn {
	display: block;
	max-width: 100%;
	font-size: 38px;
	margin: 0;
	line-height: 46px;
	color: #fff;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mine .header .user-wrapper .login-content .login-label {
	margin-top: 10px;
	font-size: 24px;
	line-height: 32px;
	color: hsla(0, 0%, 100%, .62);
}

.mine .header .user-arrow {
	flex: 0 0 auto;
	margin-left: 12px;
	color: rgba(255, 255, 255, .72);
	font-size: 34px;
}

.user-status-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	margin-top: 28px;
	padding: 0;
	border: 0;
	border-radius: 0;
	background: transparent;
}

.user-status-card {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	min-width: 0;
	min-height: 80px;
	padding: 13px 12px;
	border: 1px solid rgba(255, 255, 255, .08);
	border-radius: 12px;
	background: rgba(255, 255, 255, .06);
	box-shadow: none;
	text-align: left;
}

.status-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	width: 40px;
	height: 40px;
	margin: 0 9px 0 0;
	border-radius: 50%;
	font-size: 23px;
}

.status-icon.sex {
	color: #ff68d8;
	background: rgba(255, 104, 216, .14);
}

.status-icon.bank {
	color: #7bdcff;
	background: rgba(123, 220, 255, .14);
}

.status-icon.real {
	color: #ffd36e;
	background: rgba(255, 211, 110, .14);
}

.status-label {
	display: block;
	max-width: 100%;
	margin: 0;
	color: rgba(255, 255, 255, .78);
	font-size: 13px;
	line-height: 17px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.status-value {
	display: block;
	max-width: 100%;
	min-height: 0;
	margin: 4px 0 0;
	padding: 0;
	border-radius: 0;
	color: #fff;
	background: transparent;
	font-size: 15px;
	line-height: 20px;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-shadow: 0 2px 8px rgba(0, 0, 0, .18);
}

@media (max-width: 360px) {
	.user-status-grid {
		grid-template-columns: 1fr;
	}
}

@media (min-width: 361px) and (max-width: 420px) {
	.user-status-card {
		padding: 12px 9px;
	}

	.status-icon {
		width: 36px;
		height: 36px;
		margin-right: 7px;
		font-size: 20px;
	}

	.status-label {
		font-size: 12px;
		line-height: 16px;
	}

	.status-value {
		font-size: 14px;
		line-height: 19px;
	}
}

.mine .page-bg {
	height: 500px;
}

.mine .content {
	position: relative;
    padding: 1rem;
    background-color: #29243d;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
	color: #ffffff;
	font-size: 35px;
}

.mine .wrapper .content .finance {
	position: absolute;
	display: flex;
	align-items: center;
	top: -55px;
	left: 30px;
	right: 30px;
	height: 120px;
	background-color: #282828;
	border-radius: 15px;
	box-shadow: 0 1.5px 1px 0 #e6b98a;
}

.mine .wrapper .content .finance .line {
	width: 3px;
	height: 40px;
	background-color: #e6b98a;
}

.mine .wrapper .content .finance .finance-item {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
	margin-left: 30px;
	font-size: 30px;
	color: #e6b98a;
	font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
	font-size: 50px;
}

.mine .wrapper .content .menu {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	background-color: #282828;
	border-radius: 15px;
	box-shadow: 0 1.5px 1px 0 #e6b98a;
}

.mine .wrapper .content .menu .menu-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 50%;
	height: 130px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
	font-size: 30px;
	color: #e6b98a;
	font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
	margin: 25px;
	width: 60px;
	height: 60px;
	-o-object-fit: contain;
	object-fit: contain;
}

.mine .wrapper .content .wallet {
	margin-top: 80px;
	padding: 0 30px;
	background-color: #282828;
	border-radius: 15px;
	box-shadow: 0 1.5px 1px 0 #e6b98a;
}

.mine .wrapper .content .wallet .part-1 {
	display: flex;
	align-items: center;
	height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
	color: #e6b98a;
}

.font-gray {
	color: #e6b98a;
}

.mine .wrapper .content .wallet .part-2 {
	display: flex;
	align-items: center;
	height: 150px;
}

.mine .wrapper .content .wallet .part-2 .balance {
	flex: 1;
	font-size: 60px;
	color: #e6b98a;
	font-weight: 700;
}

.mine .wrapper .content .wallet .van-hairline--bottom::after {
	border-bottom-width: 3px;
}

.mine .wrapper .content .wallet .part-2 .refresh-btn {
	margin-left: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 50px;
	font-size: 30px;
	border-radius: 50%;
	color: #e6b98a;
	background-color: #e6c3a1;
}

::v-deep .van-tabbar-item--active {
	color: #ddb285 !important;
}

::v-deep .van-icon-peer-pay:before,
::v-deep .van-icon-idcard:before {
	color: #ecdde4;
}

::v-deep [class*=van-hairline]::after {
	border: 0 solid #e6b98a;
}

::v-deep .van-cell {
	margin-bottom: .4rem;
    font-size: .82667rem;
    line-height: 1rem;
    border-radius: .53333rem;
    color: #fff;
    background: #342f46;
	padding: 1rem .37333rem;


}

::v-deep .van-cell__title span {
	color: #fff;
	font-size: 28px;
	margin-left: 10px;
}

::v-deep .van-cell__left-icon {
	font-size: 60px;
	color: #e6b98a;
}

::v-deep .van-cell__right-icon {
	font-size: 40px;
	line-height: 1.5rem;
}

::v-deep .van-cell::after {
	border: none;
}

p {
	padding: 0;
	margin: 0;
	color: #fff;
	line-height: 30px;
	font-size: 24px;
}

.icons {
	display: flex;
	align-items: center;
}

.icons img {
	width: 48px;
	margin-right: 10px;
}

.menu-van-icon {
	width: 48px;
	margin-right: 10px;
	font-size: 48px;
	color: #a63030;
}
</style>
